import React from 'react';
import Profile from '../../components/Expert';

const Expert = function () {
  return <Profile />;
};

export default Expert;
